var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KeepAlive',[_c(_vm.tableType,{key:_vm.key,tag:"component",attrs:{"channel":_vm.channel,"currentBalances":_vm.currentBalances}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }